import React from 'react';

import { getUIFieldTypeFromDataElement } from 'dsilo-ui-components';

import CustomInputField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/input';
import CustomSelectField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/select';
import CustomApiSelectField from './apiSelect';
import CustomTextAreaField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/textArea';
import ArrayOfStringsBlock from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/arrayOfStrings';
import CustomNumberInputField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/numberInput';
import CustomArrayOfCheckboxField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/arrayOfCheckbox';
import CustomCommentSection from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/comments';
import CustomDateRangePicker from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/dateRangePicker';
import CustomCheckboxField from '../../../TrackerViewerV2/components/RenderFieldsBasedOnType/checkbox';

const RenderFieldBasedOnType = (props) => {
    const { element } = props;
    const currentType = getUIFieldTypeFromDataElement(element);

    return (
        <React.Fragment>
            {
                (function renderField() {
                    switch (currentType) {
                        case 'string':
                            return <CustomInputField key={element.type} {...props} />;
                        case 'number':
                        case 'currency':
                            return <CustomNumberInputField key={element.type} {...props} />;
                        case 'select':
                        case 'namepicker':
                            if (element?.isFetchAPI === true) {
                                return (
                                    <CustomApiSelectField
                                        key={`${element.type}_api_${element.name || element.value}`}
                                        {...props}
                                    />
                                );
                            }
                            return <CustomSelectField key={element.type} {...props} />;
                        case 'MultiCheckbox':
                            return <CustomArrayOfCheckboxField key={element.type} {...props} />;
                        case 'textarea':
                            return <CustomTextAreaField key={element.type} {...props} />;
                        case 'comments':
                            return <CustomCommentSection key={element.type} {...props} />;
                        case 'array':
                            return <ArrayOfStringsBlock key={element.type} {...props} />;
                        case 'dateRange':
                            return <CustomDateRangePicker key={element.type} {...props} />;
                        case 'checkbox':
                            return <CustomCheckboxField key={element.type} {...props} />;
                        default:
                            return <CustomInputField key={element.type} {...props} />;
                    }
                })()
            }
        </React.Fragment>
    );
};

export default RenderFieldBasedOnType;
